import { Component, OnInit, Input, HostListener } from "@angular/core";
import { Store } from "@ngrx/store";
import { IAppState } from "src/app/store/states/app.state";
import { setPeriodicity } from "src/app/utils/utils";
import { COLORS_CARDS, SCREEN_PIXELS } from "../../../layout/cobranza-digital/components/nuevas-condiciones/constants";
import {
	LoadAlternativeIndex,
	LoadAlternativeSelected
} from "../../../layout/cobranza-digital/store/actions/alternatives.action";
import {
	ICustomerData,
	IOfferList
} from "../../../layout/cobranza-digital/store/states/alternatives.state";
import { LOG1, LOG2 } from "src/app/utils/constOfTest";
import { IData } from "src/app/layout/cobranza-digital/store/states/autenticated.state";
import { Router } from "@angular/router";

const ok = 200;

const MIN_CREDIT = 1;
@Component({
	selector: "card-simple",
	templateUrl: "./card-simple.component.html",
	styleUrls: ["./card-simple.component.scss"]
})
export class CardSimpleComponent implements OnInit {
	@Input() detal: IOfferList;
	@Input() indice: number;
	@Input() newAmortizationDescription: string = "";
	@Input() buttonType: string = "";

	colors = COLORS_CARDS;
	feeDuringGracePeriod = "";
	periodicidad = "";
  saltoLinea : boolean = true;
  minCredito : number = MIN_CREDIT;
	textCredito = "Unifica"
	creditos = "de tus créditos";
	pixelesPantalla: number = SCREEN_PIXELS;
	datLog: IData = LOG1;
	dat2: ICustomerData = LOG2;
  	textoCard : string = "";


	constructor(
		private _store: Store<IAppState>,
		private router: Router
	) {
		this.getScreenSize();
	}

	ngOnInit(): void {
		this.periodicidad = setPeriodicity(this.newAmortizationDescription);
		this.feeDuringGracePeriod = this.detal.feeDuringGracePeriod;
		if (this.detal.creditsNumber > this.minCredito) {
			this.textoCard = `${this.textCredito} ${this.detal.creditsNumber} ${this.creditos}.`;
		} else{
			const ten: number = 10;
      		this.textoCard = `Cambia las condiciones de tu<br> crédito ${this.detal.details.creditsIncluded[0].loanNumber.slice(-ten)}.`;
    	}
		this._store
			.select((state) => state.alternatives)
			.subscribe((r) =>{
				this.dat2 = r.customerData;
			})
		this.getSubscribeLogs();
	}

	@HostListener("window:resize", ["$event"])
	getScreenSize() {
		if (window.innerWidth < this.pixelesPantalla) {
			this.saltoLinea = false;
		}
	}

	putSelectedAlernative() {
		this._store.dispatch(new LoadAlternativeSelected(this.detal));
		this._store.dispatch(new LoadAlternativeIndex(this.indice));
	}

	getSubscribeLogs(){
		this._store
      .select((state) => state.autenticated.data)
      .subscribe((response : IData) => {
        if(response.customerName === ""){
          this.router.navigate(["/error"]);
        }
        this.datLog = response;
      }).unsubscribe();
	}
}
